























import Vue from 'vue'
export default Vue.extend({
  props: ['size'],
  data() {
    return {
      tiles: [
        { project: 'yutari', logo: require('@/assets/image/common/yutari.svg') },
        { project: 'hontoyutari', logo: require('@/assets/image/common/hontoyutari.svg') },
        { project: 'yutariya', logo: require('@/assets/image/common/yutariya.svg') },
        { project: 'bannoubiz', logo: require('@/assets/image/common/bannoubiz.svg') },
        { project: 'bannoudesign', logo: require('@/assets/image/common/bannoudesign.svg') }
      ],
      src: '',
      alt: ''
    }
  },
  mounted() {
    const rand = Math.floor(Math.random() * (this.tiles.length))
    const tile = this.tiles[rand]
    this.src = tile.logo
    this.alt = tile.project
  }
})
